import _ from 'lodash';
import Axios, { AxiosInstance, AxiosPromise, AxiosRequestConfig } from 'axios';
import ApiService from './apiService';
import EcCommon from '../../../types/ec/ecCommon';

export const TrainerAccessServiceAxiosInstance: AxiosInstance = Axios.create({
	baseURL: window.lt.api.apimUrl + 'enterprise-coach',
	headers: {
		'Ocp-Apim-Subscription-Key': window.lt.api.apimKey,
	},
});

export default class TrainerAccessService extends ApiService implements EcCommon.ITrainerAccessService {
	constructor() {
		super('trainer-access-service', TrainerAccessServiceAxiosInstance);
	}

	public searchEmployee(employeeId: string): AxiosPromise<EcCommon.IEmployeeSearchResponse> {
		const employeeSearchRequest: EcCommon.IEmployeeSearchRequest = {
			employeeId: _.replace(employeeId, 'e', ''),
		};
		const config: object = {
			suppressError: true,
			suppressErrorCodes: [404],
		};

		return this.axiosInstance.post('employee-search/v1/search/employee', employeeSearchRequest, config);
	}

	public deactivateEmployee(partyId: number): AxiosPromise<void> {
		return this.axiosInstance.put('employee-search/v1/user/party/' + partyId + '/usertype/Employee/sourcetype/Trainerize/isactive/false');
	}

	public activateEmployee(employee: EcCommon.IEmployeeSearchResponse, trainerRole: string): AxiosPromise<EcCommon.IAddEmployeeResponse> {
		const addEmployeeRequest: EcCommon.IAddEmployeeRequest = {
			firstName: employee.firstName,
			lastName: employee.lastName,
			clubId: employee.clubId,
			clubName: employee.clubName,
			clubPrefix: employee.clubPrefix,
			emailAddress: employee.emailAddress,
			employeeNumber: employee.employeeNumber,
			sourceId: employee.sourceId,
			trainerRole,
		};

		return this.axiosInstance.post('trainer/update/create/' + employee.partyId, addEmployeeRequest);
	}
}

export const trainerAccessService = new TrainerAccessService();
